<template>
    
      <b-card>
        <b-row>
          <b-col>
            <h6><strong>{{ widgetTitle }}</strong></h6>
          </b-col>
          <div style="position:absolute; top:15px; right:20px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="salesPersonSalesFilters.salesRep" @change="onGetSalesBySalesPerson">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="salesPersonSalesSelectedDateRange" @change="onDateRangeChange">
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select>               
            </span>
            
            <b-modal size="sm" title="Custom Date for Sales Person's Sales" id="custom-date-sales-person-sales" @ok="onCustomSet" no-close-on-backdrop>
              <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
                <b-form-group label="From" class="mb-4 mr-2" >
                  <date-picker v-model="salesPersonSalesFilters.dateFrom" :config="datePickerOptions" size="sm" />
                </b-form-group>
                <b-form-group label="To" class="mb-4">
                  <date-picker v-model="salesPersonSalesFilters.dateTo" :config="datePickerOptions" size="sm" />
                </b-form-group>
              </div>
            </b-modal>
          </div>
          
        </b-row>
        <div class="sales-scrollable">
          <vue-good-table
            ref="SalesPersonTable"
            :isLoading="isLoadingWidget"
            :columns="fields"
            :rows="salesBySalesRep"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.cell == 'formatProgress'">
                <h6>Sales: ${{ commafy(props.row[props.column.field]) }}</h6> 
                
                <b-progress :max="props.row[props.column.maxField]" :precision="2" show-progress>
                  <b-progress-bar :value="props.row[props.column.field]" :variant="getBarColor(props.row[props.column.field], props.row[props.column.maxField])">
                     <strong>{{ commafy(props.row[props.column.field]) }} / {{ commafy(props.row[props.column.maxField]) }}</strong>
                  </b-progress-bar>
                </b-progress>
              </span>
              <!-- <span v-else-if="props.column.cell == 'formatMoney'">
                ${{ commafy(props.row[props.column.field]) }}
              </span> -->
              <span v-else>
                {{ props.row[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </b-card>  
</template>

<script>
  import {VueGoodTable} from 'vue-good-table';
  import 'vue-good-table/dist/vue-good-table.css';
  import BarChart from './../extensions/BarChart.js'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components: {
      BarChart,
      VueGoodTable
    },
    data () {
      return {
        datacollection: null,
        fields: [
          {
            label: 'Sales Rep',
            field: 'fullName',
            width: '200px'
          },
          // {
          //   label: 'Sales Bogey',
          //   field: 'saleQuota',
          //   cell: 'formatMoney',
          //   width: '100px'
          // },
          {
            field: 'sales',
            maxField: 'saleQuota',
            label: 'Sales',
            cell: 'formatProgress',
            sortable: false,
            width: '500px'
          }
        ],
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        salesBySalesRep: [],
        widgetTitle: 'Sales by Sales Person'
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapGetters('dashboard', ['salesPersonSalesSelectedDateRange', 'salesPersonSalesFilters']),
      ...mapState('salesReps', ['salesReps'])
    }, 
    methods: {
      ...mapActions('dashboard', ['getSalesBySalesPerson']),
      ...mapMutations('dashboard', ['setItem']),
      getBarColor(val, max) {
        var percentage = (val / max) * 100;

        
        if (percentage >= 100)
          return 'success';
        else if (percentage <= 20 && percentage > 10)
          return 'warning';
        else if (percentage <= 10)
          return 'danger';
        else 
          return 'info';
        
      },
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.salesPersonSalesFilters.dateFrom = null;
          this.salesPersonSalesFilters.dateTo= null;
          this.$bvModal.show('custom-date-sales-person-sales');
        } else {
          
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.widgetTitle = (dateFrom && dateTo) ? 'Sales by Sales Person for ' + dateFrom + ' to ' + dateTo : 'Sales By Sales Person'
          this.salesPersonSalesFilters.dateFrom = dateFrom;
          this.salesPersonSalesFilters.dateTo= dateTo;
          this.onGetSalesBySalesPerson();
        }

        this.setItem({ resource: 'salesPersonSalesSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.salesPersonSalesFilters.dateFrom && this.salesPersonSalesFilters.dateTo) {
          this.widgetTitle = 'Sales by Sales Person for ' + this.salesPersonSalesFilters.dateFrom + ' to ' + this.salesPersonSalesFilters.dateTo;
          this.onGetSalesBySalesPerson();
          
        }
        this.$bvModal.hide('custom-date-sales-person-sales');
      },
      async onGetSalesBySalesPerson() {
        this.isLoadingWidget = true;

        await this.getSalesBySalesPerson(this.salesPersonSalesFilters).then((res) => { 
          this.salesBySalesRep = res;
          this.isLoadingWidget = false;
        });
      },
      commafy(num, decimal = 2) {
        try {
          if (num != null) {
            var str = num.toString().split('.');
            if (str[0].length >= 3) {
              str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            if (str[1]) {
              if (str[1].length < decimal) {
                while (str[1].length < decimal) { str[1] = str[1] + "0"; }
              } else if (str[1].length > decimal) {
                str[1] = str[1].substring(0, decimal)
              }
            }
            return str.join('.');
          }
        } catch {
          return num;
        }
      },
    },
    mounted () {
      const { dateFrom, dateTo } = getDatesFromRangeString(this.salesPersonSalesSelectedDateRange);
      this.widgetTitle = (dateFrom && dateTo) ? 'Sales by Sales Person for ' + dateFrom + ' to ' + dateTo : 'Sales By Sales Person';
      this.salesPersonSalesFilters.dateFrom = dateFrom;
      this.salesPersonSalesFilters.dateTo = dateTo;
      this.onGetSalesBySalesPerson();   
    },
  }
</script>

<style lang="scss">
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
  .sales-scrollable {
    max-height: 250px !important;
    // height: auto;
    overflow-y: auto;
  }
</style>